import React from 'react';

class SMButton extends React.Component {
  
  onClick(e) {
    if(this.props.delegate && typeof this.props.delegate.buttonDidClick === 'function'){
      e.preventDefault();
      this.props.delegate.buttonDidClick(e.currentTarget.name);
    }
  }
  
  render() {
    return (
      <a href={this.props.link} name={this.props.name} onClick={this.onClick.bind(this)} className={this.props.options.className}>{this.props.label}</a>
    );
  }
}
SMButton.defaultProps = {
  options: {
    name: 'button',
    className: 'button-green'
  }
};
export default SMButton;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMButton.jsx